/*Author - Subhalakshmi S
Date - 21-04-2025
Task - Audit Logs */
import React, { useContext, useEffect, useState } from "react";
import AdminLayout from "../../../components/layouts/adminLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import { useNavigate } from "react-router";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import AuditLogService from "../../../services/API/AuditLogService";
import Pagination from "react-js-pagination";
import { Modal } from "react-bootstrap";
import moment from "moment";

export default function AuditLogs() {
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [myData, setMyData] = useState([]);
  const [id, setId] = useState(null);
  const [edit, setEdit] = useState(false);
  const [oldData, setOldData] = useState(false);
  const [changedData, setChangedData] = useState(false);
  const [menu, setMenu] = useState([]);
  const [menuItem, setMenuItem] = useState(false);

  const postsPerPage = 20;

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const indexOfLastPost = page * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const queryKey = "api/audit-logs";
  const payload = {start: indexOfFirstPost, end:indexOfLastPost, menu:menuItem};
  const {
    data: auditLog,
    isLoading: loading,
    isSuccess: success,
    isFetching,
    refetch,
  } = useQuery([queryKey, indexOfFirstPost, indexOfLastPost, menuItem], AuditLogService.getAuditLogsList, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
  
  const auditLogs = auditLog?.data?.data;

  useEffect(() => {
    if (auditLog?.data?.data) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setMyData(auditLog?.data?.data);
      setMenu(auditLog?.data?.model);
    }
  }, [auditLog]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [page]);

  const navigate = useNavigate();

  const handleEdit = async (log) => {
    try {
        const logData = await AuditLogService.editAuditLog(log?.id);
    
        setId(log?.id);
        setEdit(logData?.data);
        if (logData?.data) {
            setOldData(logData?.data?.old_data);
            setChangedData(logData?.data?.changed_data);
            setShow(true);
        }
    } catch (er) {
      toast.error(er);
    }
  };

  const handleHide = () => {
    setShow(false);
  };

  //23-05-2025 - Docs download - Subha
  const downloadDocs = async (id) => {
    try {
      const response = await AuditLogService.downloadFileById(id);
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response]));
       
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'sample.pdf'); // Set your desired file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // Clean up
        toast.success("File Downloaded Successfully");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  function toTitleCase(str) {
    return str
      .split('_') // Split by underscore
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' ');
  }

  return (
    <AdminLayout test="active">
      <AdminPageContainer>
        <div id="main" role="main">
          <div id="content">
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  <a
                    style={{
                      color: "blue",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/system-admin/license-master")}
                    onKeyDown={() => navigate("/system-admin/license-master")}
                  >
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item active">Audit Logs</li>
              </ol>
            </div>

            <div>
              <div className="row">
                <div className="card card-sm card-shadow mb-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                    <h2
                        style={{
                          fontWeight: "bold",
                          marginBottom: "0",
                        }}
                      >
                        Audit Logs
                      </h2>
                    </div>

                    <div style={{ borderTop: "0px" }}>
                        <div
                            style={{
                            paddingTop: "30px",
                            }}
                            className="d-flex justify-content-end align-items-center gap-2 p-2"
                        >
                          <label className="input">
                            <select className="input-sm rounded" 
                                onChange={(e) => {
                                  setMenuItem(e.target.value);
                                  setPage(1);
                                }}>
                               <option value="">Select Menu</option>
                               {menu?.length !== 0 ? (
                                menu?.map((item) => {
                                    return (
                                      <option value={item}>{item=='IndustryType'?"Business Type":item}</option>
                                    );
                                })
                                ) : ""}
                            </select>
                           </label>
                        </div>

                        <div className="table-responsive ">
                            <table
                            className="table  table-bordered table-hover dataTable no-footer"
                            style={{ tableLayout: "fixed" }}
                            >
                            <thead>
                                <tr role="row" style={{ fontWeight: 700 }}>
                                <th className="text-center" width="34px">
                                    S. No.
                                </th>
                                <th className="text-center">Menu Name</th>
                                <th className="text-center">Action Type</th>
                                <th className="text-center">Changed By</th>
                                <th className="text-center">Modified Date</th>
                                <th className="text-center" width="50px">
                                    Actions
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                {auditLogs?.length !== 0 ? (
                                auditLogs?.map((log, index) => {
                                    return (
                                    <tr key={log?.id}>
                                        <td className="text-start align-middle">
                                        {postsPerPage * (page - 1) + index + 1}
                                        </td>
                                        <td className="text-start align-middle">
                                        {log?.model=='IndustryType'?"Business Type":log?.model}
                                        </td>
                                        <td className="text-start align-middle">
                                        {log?.action_type}
                                        </td>
                                        <td className="text-start align-middle">
                                        {log?.email}
                                        </td>
                                        <td className="text-start align-middle">
                                        {moment(log?.created_at).format("DD-MM-YY hh:mm A")}
                                        </td>
                                        <td className="text-start align-middle">
                                        <a
                                            title="View"
                                            onClick={() => handleEdit(log)}
                                            onKeyDown={() => handleEdit(log)}
                                        >
                                            <i className="fa fa-eye fa-fw cursor-pointer"></i>
                                        </a>
                                        </td>
                                    </tr>
                                    );
                                })
                                ) : (
                                <tr>
                                    <td colSpan={6} className="p-2 text-center">
                                    {loading || isFetching
                                        ? "Loading..."
                                        : "No data found"}
                                    </td>
                                </tr>
                                )}
                            </tbody>
                            </table>
                            {auditLog?.data?.count > postsPerPage && (
                                <Pagination
                                    activePage={page}
                                    itemsCountPerPage={postsPerPage}
                                    totalItemsCount={auditLog?.data?.count}
                                    pageRangeDisplayed={postsPerPage}
                                    onChange={handlePageChange}
                                />
                            )}
                        </div>

                        {show && (
                            <Modal
                            show={show}
                            animation={false}
                            onHide={handleHide}
                            dialogClassName="modal-lg"
                            >
                                <Modal.Header closeButton>
                                    <h3 className="modal-title">View</h3>
                                </Modal.Header>
                                <Modal.Body
                                    style={{ height: "80vh", overflowY: "scroll" }}
                                >
                                    <div className="table-responsive ">
                                        <table
                                        className="table  table-bordered table-hover dataTable no-footer"
                                        style={{ tableLayout: "fixed" }}
                                        >
                                        <thead>
                                            <tr role="row" style={{ fontWeight: 700 }}>
                                                <th className="text-center">Old Data</th>
                                                <th className="text-center">New Data</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-start align-middle">
                                                    {Object.entries(oldData).map(([key, value]) => (
                                                        value ? 
                                                        
                                                        // <p key={key}>
                                                        //   <strong>{key}:</strong> {value ?? "N/A"}
                                                        // </p> : ''
                                                        
                                                        //23-05-2025 - Docs download - Subha
                                                        (
                                                          <p key={key}>
                                                            <strong>{toTitleCase(key)}:</strong>{" "}
                                                            {key === "path" ? (
                                                              <a className="cursor-pointer"
                                                                onClick={() => downloadDocs(oldData?.id)}
                                                              >
                                                                Click Here <i className="fa fa-download"></i>
                                                              </a>
                                                            ) : (
                                                              value ?? "N/A"
                                                            )}
                                                          </p>
                                                        ) : null
                                                    ))}
                                                </td>
                                                <td className="text-start align-middle">
                                                    {Object.entries(changedData).map(([key, value]) => (
                                                        value ? 
                                                        (
                                                          <p key={key}>
                                                            <strong>{toTitleCase(key)}:</strong>{" "}
                                                            {key === "path" ? (
                                                              <a className="cursor-pointer"
                                                                onClick={() => downloadDocs(oldData?.id)}
                                                              >
                                                                Click Here <i className="fa fa-download"></i>
                                                              </a>
                                                            ) : (
                                                              value ?? "N/A"
                                                            )}
                                                          </p>
                                                        ) : null
                                                    ))}
                                                </td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminPageContainer>
    </AdminLayout>
  );
}
